export default __webpack_public_path__ + "static/media/index.13ad51ac.less";